// import { X } from "lucide-react";
// import { useEffect } from "react";
// import { useForm } from "react-hook-form";
// import { useUpdateGlobalConfig } from "../hooks/updateGlobalConfig";
// import { useResetGlobalConfig } from "../hooks/resetGlobalConfig";

// export const EditGlobalModal = ({ isOpen, onClose, defaultValues }) => {
//     const { mutate: updateConfig, isPending } = useUpdateGlobalConfig();
//     const { mutate: resetConfig, isPending: isResetting } = useResetGlobalConfig();

//     const {
//         register,
//         handleSubmit,
//         reset,
//         formState: { errors },
//     } = useForm({
//         defaultValues: {
//             search_radius_in_meter: defaultValues?.search_radius_in_meter,
//             min_age: defaultValues?.min_age,
//             max_age: defaultValues?.max_age,
//             platform_fees: defaultValues?.platform_fees,
//             gst_percentage: defaultValues?.gst_percentage,
//              booking_commission_percentage: defaultValues?.booking_commission_percentage,
//     booking_commission_waiver_days: defaultValues?.booking_commission_waiver_days,
//         support_contact_number: defaultValues?.support_contact_number,

//         },
//     });

//     // Fill form when modal opens
//     useEffect(() => {
//         if (isOpen && defaultValues) {
//             reset({
//                 search_radius_in_meter: defaultValues.search_radius_in_meter,
//                 min_age: defaultValues.min_age,
//                 max_age: defaultValues.max_age,
//                 platform_fees: defaultValues.platform_fees,
//                 gst_percentage: defaultValues.gst_percentage,
//                 booking_commission_percentage: defaultValues.booking_commission_percentage,
//     booking_commission_waiver_days: defaultValues.booking_commission_waiver_days,
//         support_contact_number: defaultValues.support_contact_number,

//             });
//         }
//     }, [isOpen, defaultValues, reset]);

//     if (!isOpen) return null;

//     // Submit handler
//     const onSubmit = (data) => {
//         const payload = {
//             search_radius_in_meter: Number(data.search_radius_in_meter),
//             min_age: Number(data.min_age),
//             max_age: Number(data.max_age),
//             platform_fees: Number(data.platform_fees),
//             gst_percentage: Number(data.gst_percentage),
//              booking_commission_percentage: Number(data.booking_commission_percentage),
//     booking_commission_waiver_days: Number(data.booking_commission_waiver_days),
//         support_contact_number: data.support_contact_number,

//         };

//         updateConfig(payload, {
//             onSuccess: () => onClose(),
//         });
//     };

//     // Reset configuration
//     const handleReset = () => {
//         resetConfig(undefined, {
//             onSuccess: (res) => {
//                 const newValues = res.data;
//                 reset({
//                     search_radius_in_meter: newValues.search_radius_in_meter,
//                     min_age: newValues.min_age,
//                     max_age: newValues.max_age,
//                     platform_fees: newValues.platform_fees,
//                     gst_percentage: newValues.gst_percentage,
//                 });
//                 onClose();
//             },
//         });
//     };

//     return (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
//             <div className="bg-card rounded-lg shadow-xl w-full max-w-md border border-border">

//                 {/* Header */}
//                 <div className="flex items-center justify-between px-6 py-4 border-b border-border">
//                     <h3 className="text-lg font-semibold text-foreground">Edit Preferences</h3>
//                     <button onClick={onClose} className="text-muted-foreground hover:text-foreground">
//                         <X size={20} />
//                     </button>
//                 </div>

//                 <form onSubmit={handleSubmit(onSubmit)} className="p-6 space-y-5">

//                     {/* Search Radius */}
//                     <div>
//                         <label className="block text-sm text-muted-foreground mb-1">
//                             Search Radius (meters)
//                         </label>
//                         <input
//                             type="number"
//                             {...register("search_radius_in_meter", {
//                                 required: "Search radius is required",
//                             })}
//                             className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
//                         />
//                         {errors.search_radius_in_meter && (
//                             <p className="text-destructive text-xs mt-1">
//                                 {errors.search_radius_in_meter.message}
//                             </p>
//                         )}
//                     </div>

//                     {/* Min Age */}
//                     {/* <div>
//                         <label className="block text-sm text-muted-foreground mb-1">Min Age</label>
//                         <input
//                             type="number"
//                             {...register("min_age", {
//                                 required: "Minimum age is required",
//                             })}
//                             className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
//                         />
//                         {errors.min_age && (
//                             <p className="text-destructive text-xs mt-1">{errors.min_age.message}</p>
//                         )}
//                     </div> */}

//                     {/* Max Age */}
//                     {/* <div>
//                         <label className="block text-sm text-muted-foreground mb-1">Max Age</label>
//                         <input
//                             type="number"
//                             {...register("max_age", {
//                                 required: "Maximum age is required",
//                             })}
//                             className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
//                         />
//                         {errors.max_age && (
//                             <p className="text-destructive text-xs mt-1">{errors.max_age.message}</p>
//                         )}
//                     </div> */}

//                     {/* PlatForm Fees */}
//                     <div>
//                         <label className="block text-sm text-muted-foreground mb-1">Platform Fees</label>
//                         <input
//                             type="number"
//                             {...register("platform_fees", {
//                                 required: "Platform fees is required",
//                             })}
//                             className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
//                         />
//                         {errors.platform_fees && (
//                             <p className="text-destructive text-xs mt-1">{errors.platform_fees.message}</p>
//                         )}
//                     </div>

//                     {/* GST Percentage */}
//                     <div>
//                         <label className="block text-sm text-muted-foreground mb-1">GST Percentage</label>
//                         <input
//                             type="number"
//                             {...register("gst_percentage", {
//                                 required: "GST percentage is required",
//                             })}
//                             className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
//                         />
//                         {errors.gst_percentage && (
//                             <p className="text-destructive text-xs mt-1">{errors.gst_percentage.message}</p>
//                         )}
//                     </div>

//                     {/* Booking Commission Percentage */}
// <div>
//     <label className="block text-sm text-muted-foreground mb-1">
//         Booking Commission (%)
//     </label>
//     <input
//         type="number"
//         {...register("booking_commission_percentage", {
//             required: "Booking commission percentage is required",
//         })}
//         className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
//     />
//     {errors.booking_commission_percentage && (
//         <p className="text-destructive text-xs mt-1">
//             {errors.booking_commission_percentage.message}
//         </p>
//     )}
// </div>

// {/* Booking Commission Waiver Days */}
// <div>
//     <label className="block text-sm text-muted-foreground mb-1">
//         Commission Waiver Days
//     </label>
//     <input
//         type="number"
//         {...register("booking_commission_waiver_days", {
//             required: "Commission waiver days is required",
//         })}
//         className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
//     />
//     {errors.booking_commission_waiver_days && (
//         <p className="text-destructive text-xs mt-1">
//             {errors.booking_commission_waiver_days.message}
//         </p>
//     )}
// </div>

// <div>
//     <label className="block text-sm text-muted-foreground mb-1">
//         Support Contact Number
//     </label>

//     <input
//         type="text"
//         {...register("support_contact_number", {
//             required: "Support contact number is required",
//         })}
//         className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
//     />

//     {errors.support_contact_number && (
//         <p className="text-destructive text-xs mt-1">
//             {errors.support_contact_number.message}
//         </p>
//     )}
// </div>

// {/* Buttons */}
// <div className="flex gap-3"></div>

//                     {/* Buttons */}
//                     <div className="flex gap-3">


//                         {/* RESET BUTTON */}
//                         <button
//                             type="button"
//                             disabled={isPending || isResetting}
//                             onClick={handleReset}
//                             className="px-4 py-2 border border-destructive text-destructive rounded-md hover:bg-destructive hover:text-white disabled:opacity-50 transition-colors"
//                         >
//                             {isResetting ? "Resetting..." : "Reset to Default"}
//                         </button>

//                         <button
//                             type="button"
//                             disabled={isPending}
//                             onClick={onClose}
//                             className="px-4 py-2 border border-border text-muted-foreground rounded-md hover:bg-accent hover:text-foreground transition-colors"
//                         >
//                             Cancel
//                         </button>

//                         <button
//                             type="submit"
//                             disabled={isPending}
//                             className="px-4 py-2 bg-primary hover:bg-primary/90 text-primary-foreground rounded-md transition-colors disabled:opacity-50"
//                         >
//                             {isPending ? "Updating..." : "Update settings"}
//                         </button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };





import { X, Smartphone, ShieldAlert, Banknote } from "lucide-react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useUpdateGlobalConfig } from "../hooks/updateGlobalConfig";
import { useResetGlobalConfig } from "../hooks/resetGlobalConfig";

export const EditGlobalModal = ({ isOpen, onClose, defaultValues }) => {
  const { mutate: updateConfig, isPending } = useUpdateGlobalConfig();
  const { mutate: resetConfig, isPending: isResetting } =
    useResetGlobalConfig();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      search_radius_in_meter: defaultValues?.search_radius_in_meter,
      min_age: defaultValues?.min_age,
      max_age: defaultValues?.max_age,
      platform_fees: defaultValues?.platform_fees,
      gst_percentage: defaultValues?.gst_percentage,
      booking_commission_percentage:
        defaultValues?.booking_commission_percentage,
      booking_commission_waiver_days:
        defaultValues?.booking_commission_waiver_days,
      support_contact_number: defaultValues?.support_contact_number,
      support_contact_email: defaultValues?.support_contact_email,
      is_cod_enabled: defaultValues?.is_cod_enabled ?? true,
      cod_max_due_limit: defaultValues?.cod_max_due_limit ?? 80,
      provider_app_min_supported_version_ios:
        defaultValues?.provider_app_min_supported_version_ios,
      provider_app_min_supported_version_android:
        defaultValues?.provider_app_min_supported_version_android,
      provider_app_latest_version_ios:
        defaultValues?.provider_app_latest_version_ios,
      provider_app_latest_version_android:
        defaultValues?.provider_app_latest_version_android,
      provider_app_force_update_enabled:
        defaultValues?.provider_app_force_update_enabled,
      provider_app_update_message: defaultValues?.provider_app_update_message,
      customer_app_min_supported_version_ios:
        defaultValues?.customer_app_min_supported_version_ios,
      customer_app_min_supported_version_android:
        defaultValues?.customer_app_min_supported_version_android,
      customer_app_latest_version_ios:
        defaultValues?.customer_app_latest_version_ios,
      customer_app_latest_version_android:
        defaultValues?.customer_app_latest_version_android,
      customer_app_force_update_enabled:
        defaultValues?.customer_app_force_update_enabled,
      customer_app_update_message: defaultValues?.customer_app_update_message,
    },
  });

  // Fill form when modal opens
  useEffect(() => {
    if (isOpen && defaultValues) {
      reset({
        search_radius_in_meter: defaultValues.search_radius_in_meter,
        min_age: defaultValues.min_age,
        max_age: defaultValues.max_age,
        platform_fees: defaultValues.platform_fees,
        gst_percentage: defaultValues.gst_percentage,
        booking_commission_percentage:
          defaultValues.booking_commission_percentage,
        booking_commission_waiver_days:
          defaultValues.booking_commission_waiver_days,
        support_contact_number: defaultValues.support_contact_number,
        support_contact_email: defaultValues.support_contact_email,
        is_cod_enabled: defaultValues.is_cod_enabled ?? true,
        cod_max_due_limit: defaultValues.cod_max_due_limit ?? 80,
        provider_app_min_supported_version_ios:
          defaultValues.provider_app_min_supported_version_ios,
        provider_app_min_supported_version_android:
          defaultValues.provider_app_min_supported_version_android,
        provider_app_latest_version_ios:
          defaultValues.provider_app_latest_version_ios,
        provider_app_latest_version_android:
          defaultValues.provider_app_latest_version_android,
        provider_app_force_update_enabled:
          defaultValues.provider_app_force_update_enabled,
        provider_app_update_message: defaultValues.provider_app_update_message,
        customer_app_min_supported_version_ios:
          defaultValues.customer_app_min_supported_version_ios,
        customer_app_min_supported_version_android:
          defaultValues.customer_app_min_supported_version_android,
        customer_app_latest_version_ios:
          defaultValues.customer_app_latest_version_ios,
        customer_app_latest_version_android:
          defaultValues.customer_app_latest_version_android,
        customer_app_force_update_enabled:
          defaultValues.customer_app_force_update_enabled,
        customer_app_update_message: defaultValues.customer_app_update_message,
      });
    }
  }, [isOpen, defaultValues, reset]);

  if (!isOpen) return null;

  // Submit handler
  const onSubmit = (data) => {
    const payload = {};

    if (data.search_radius_in_meter !== undefined && data.search_radius_in_meter !== '') {
      payload.search_radius_in_meter = Number(data.search_radius_in_meter);
    }
    if (data.platform_fees !== undefined && data.platform_fees !== '') {
      payload.platform_fees = Number(data.platform_fees);
    }
    if (data.gst_percentage !== undefined && data.gst_percentage !== '') {
      payload.gst_percentage = Number(data.gst_percentage);
    }
    if (data.booking_commission_percentage !== undefined && data.booking_commission_percentage !== '') {
      payload.booking_commission_percentage = Number(data.booking_commission_percentage);
    }
    if (data.booking_commission_waiver_days !== undefined && data.booking_commission_waiver_days !== '') {
      payload.booking_commission_waiver_days = Number(data.booking_commission_waiver_days);
    }
    if (data.support_contact_number !== undefined) {
      payload.support_contact_number = data.support_contact_number;
    }
    if (data.support_contact_email !== undefined) {
      payload.support_contact_email = data.support_contact_email;
    }

    payload.is_cod_enabled = !!data.is_cod_enabled;

    if (data.cod_max_due_limit !== undefined && data.cod_max_due_limit !== '') {
      payload.cod_max_due_limit = Number(data.cod_max_due_limit);
    } else {
      payload.cod_max_due_limit = 80;
    }

    if (data.provider_app_min_supported_version_ios !== undefined) {
      payload.provider_app_min_supported_version_ios = data.provider_app_min_supported_version_ios;
    }
    if (data.provider_app_min_supported_version_android !== undefined) {
      payload.provider_app_min_supported_version_android = data.provider_app_min_supported_version_android;
    }
    if (data.provider_app_latest_version_ios !== undefined) {
      payload.provider_app_latest_version_ios = data.provider_app_latest_version_ios;
    }
    if (data.provider_app_latest_version_android !== undefined) {
      payload.provider_app_latest_version_android = data.provider_app_latest_version_android;
    }
    payload.provider_app_force_update_enabled = !!data.provider_app_force_update_enabled;
    if (data.provider_app_update_message !== undefined) {
      payload.provider_app_update_message = data.provider_app_update_message;
    }

    if (data.customer_app_min_supported_version_ios !== undefined) {
      payload.customer_app_min_supported_version_ios = data.customer_app_min_supported_version_ios;
    }
    if (data.customer_app_min_supported_version_android !== undefined) {
      payload.customer_app_min_supported_version_android = data.customer_app_min_supported_version_android;
    }
    if (data.customer_app_latest_version_ios !== undefined) {
      payload.customer_app_latest_version_ios = data.customer_app_latest_version_ios;
    }
    if (data.customer_app_latest_version_android !== undefined) {
      payload.customer_app_latest_version_android = data.customer_app_latest_version_android;
    }
    payload.customer_app_force_update_enabled = !!data.customer_app_force_update_enabled;
    if (data.customer_app_update_message !== undefined) {
      payload.customer_app_update_message = data.customer_app_update_message;
    }

    updateConfig(payload, {
      onSuccess: () => onClose(),
    });
  };

  // Reset configuration
  const handleReset = () => {
    resetConfig(undefined, {
      onSuccess: (res) => {
        const newValues = res.data;
        reset({
          search_radius_in_meter: newValues.search_radius_in_meter,
          min_age: newValues.min_age,
          max_age: newValues.max_age,
          platform_fees: newValues.platform_fees,
          gst_percentage: newValues.gst_percentage,
          booking_commission_percentage:
            newValues.booking_commission_percentage,
          booking_commission_waiver_days:
            newValues.booking_commission_waiver_days,
          support_contact_number: newValues.support_contact_number,
          support_contact_email: newValues.support_contact_email,
          is_cod_enabled: newValues.is_cod_enabled ?? true,
          cod_max_due_limit: newValues.cod_max_due_limit ?? 80,
          provider_app_min_supported_version_ios:
            newValues.provider_app_min_supported_version_ios,
          provider_app_min_supported_version_android:
            newValues.provider_app_min_supported_version_android,
          provider_app_latest_version_ios:
            newValues.provider_app_latest_version_ios,
          provider_app_latest_version_android:
            newValues.provider_app_latest_version_android,
          provider_app_force_update_enabled:
            newValues.provider_app_force_update_enabled,
          provider_app_update_message: newValues.provider_app_update_message,
          customer_app_min_supported_version_ios:
            newValues.customer_app_min_supported_version_ios,
          customer_app_min_supported_version_android:
            newValues.customer_app_min_supported_version_android,
          customer_app_latest_version_ios:
            newValues.customer_app_latest_version_ios,
          customer_app_latest_version_android:
            newValues.customer_app_latest_version_android,
          customer_app_force_update_enabled:
            newValues.customer_app_force_update_enabled,
          customer_app_update_message: newValues.customer_app_update_message,
        });
        onClose();
      },
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-card rounded-lg shadow-xl w-full max-w-4xl border border-border max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-border flex-shrink-0">
          <h3 className="text-lg font-semibold text-foreground">
            Edit Preferences
          </h3>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground"
          >
            <X size={20} />
          </button>
        </div>

        <form
          onSubmit={handleSubmit(onSubmit)}
          className="p-6 space-y-5 overflow-y-auto"
        >
          <div>
            <h4 className="text-sm font-semibold text-foreground">
              Platform Settings
            </h4>
            <p className="text-xs text-muted-foreground mt-0.5">
              General settings that apply platform-wide, across both the provider and customer apps — not specific to either one.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-4">
          {/* Search Radius */}
          <div>
            <label className="block text-sm text-muted-foreground mb-1">
              Search Radius (meters)
            </label>
            <input
              type="number"
              {...register("search_radius_in_meter", {
                required: "Search radius is required",
              })}
              className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
            />
            {errors.search_radius_in_meter && (
              <p className="text-destructive text-xs mt-1">
                {errors.search_radius_in_meter.message}
              </p>
            )}
          </div>

          {/* Min Age */}
          {/* <div>
                        <label className="block text-sm text-muted-foreground mb-1">Min Age</label>
                        <input
                            type="number"
                            {...register("min_age", {
                                required: "Minimum age is required",
                            })}
                            className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
                        />
                        {errors.min_age && (
                            <p className="text-destructive text-xs mt-1">{errors.min_age.message}</p>
                        )}
                    </div> */}

          {/* Max Age */}
          {/* <div>
                        <label className="block text-sm text-muted-foreground mb-1">Max Age</label>
                        <input
                            type="number"
                            {...register("max_age", {
                                required: "Maximum age is required",
                            })}
                            className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
                        />
                        {errors.max_age && (
                            <p className="text-destructive text-xs mt-1">{errors.max_age.message}</p>
                        )}
                    </div> */}

          {/* PlatForm Fees */}
          <div>
            <label className="block text-sm text-muted-foreground mb-1">
              Platform Fees
            </label>
            <input
              type="number"
              {...register("platform_fees", {
                required: "Platform fees is required",
              })}
              className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
            />
            {errors.platform_fees && (
              <p className="text-destructive text-xs mt-1">
                {errors.platform_fees.message}
              </p>
            )}
          </div>

          {/* GST Percentage */}
          <div>
            <label className="block text-sm text-muted-foreground mb-1">
              GST Percentage
            </label>
            <input
              type="number"
              {...register("gst_percentage", {
                required: "GST percentage is required",
              })}
              className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
            />
            {errors.gst_percentage && (
              <p className="text-destructive text-xs mt-1">
                {errors.gst_percentage.message}
              </p>
            )}
          </div>

          {/* Booking Commission Percentage */}
          <div>
            <label className="block text-sm text-muted-foreground mb-1">
              Booking Commission (%)
            </label>
            <input
              type="number"
              {...register("booking_commission_percentage", {
                required: "Booking commission percentage is required",
              })}
              className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
            />
            {errors.booking_commission_percentage && (
              <p className="text-destructive text-xs mt-1">
                {errors.booking_commission_percentage.message}
              </p>
            )}
          </div>

          {/* Booking Commission Waiver Days */}
          <div>
            <label className="block text-sm text-muted-foreground mb-1">
              Commission Waiver Days
            </label>
            <input
              type="number"
              {...register("booking_commission_waiver_days", {
                required: "Commission waiver days is required",
              })}
              className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
            />
            {errors.booking_commission_waiver_days && (
              <p className="text-destructive text-xs mt-1">
                {errors.booking_commission_waiver_days.message}
              </p>
            )}
          </div>

          {/* Support Contact Number */}
          <div>
            <label className="block text-sm text-muted-foreground mb-1">
              Support Contact Number
            </label>

            <input
              type="text"
              {...register("support_contact_number", {
                required: "Support contact number is required",
              })}
              className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
            />

            {errors.support_contact_number && (
              <p className="text-destructive text-xs mt-1">
                {errors.support_contact_number.message}
              </p>
            )}
          </div>

          {/* Support Contact Email */}
          <div>
            <label className="block text-sm text-muted-foreground mb-1">
              Support Contact Email
            </label>

            <input
              type="email"
              {...register("support_contact_email", {
                required: "Support contact email is required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Enter a valid email address",
                },
              })}
              className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
            />

            {errors.support_contact_email && (
              <p className="text-destructive text-xs mt-1">
                {errors.support_contact_email.message}
              </p>
            )}
          </div>
          </div>

          {/* Cash On Delivery (COD) Settings */}
          <div className="pt-5 mt-1 border-t border-border">
            <div className="flex items-center gap-2.5 mb-1">
              <div className="w-7 h-7 rounded-md bg-primary/10 text-primary flex items-center justify-center shrink-0">
                <Banknote size={15} />
              </div>
              <h4 className="text-sm font-semibold text-foreground">
                Cash On Delivery (COD) Settings
              </h4>
            </div>
            <p className="text-xs text-muted-foreground mb-4 pl-9">
              Control Cash on Delivery availability across the platform and set the maximum outstanding commission limit for service providers.
            </p>

            <div className="rounded-xl border border-border bg-muted/20 p-4 space-y-4">
              <div className="flex items-center justify-between gap-3 bg-card border border-border rounded-md px-3 py-2.5">
                <div className="min-w-0">
                  <span className="text-sm font-medium text-foreground block">
                    Enable Cash on Delivery (COD)
                  </span>
                  <span className="text-xs text-muted-foreground">
                    When enabled, customers can choose COD at checkout. When disabled, only online payments are allowed platform-wide.
                  </span>
                </div>
                <label className="relative inline-flex items-center cursor-pointer shrink-0">
                  <input
                    type="checkbox"
                    {...register("is_cod_enabled")}
                    className="sr-only peer"
                  />
                  <div className="w-10 h-5 bg-border rounded-full peer-checked:bg-primary transition-colors" />
                  <div className="absolute left-0.5 top-0.5 w-4 h-4 bg-white rounded-full shadow transition-transform peer-checked:translate-x-5" />
                </label>
              </div>

              <div>
                <label className="block text-sm text-muted-foreground mb-1">
                  Default Provider COD Max Due Limit (₹)
                </label>
                <input
                  type="number"
                  {...register("cod_max_due_limit", {
                    min: { value: 0, message: "Limit cannot be negative" },
                  })}
                  className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
                  placeholder="80"
                />
                <p className="text-xs text-muted-foreground mt-1">
                  When a provider collects cash for bookings, admin commission accumulates as COD dues. If their dues reach this limit, COD is automatically blocked for that provider until dues are cleared.
                </p>
                {errors.cod_max_due_limit && (
                  <p className="text-destructive text-xs mt-1">
                    {errors.cod_max_due_limit.message}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* App Version Control */}
          <div className="pt-5 mt-1 border-t border-border">
            <div className="flex items-center gap-2.5 mb-1">
              <div className="w-7 h-7 rounded-md bg-primary/10 text-primary flex items-center justify-center shrink-0">
                <Smartphone size={15} />
              </div>
              <h4 className="text-sm font-semibold text-foreground">
                App Version Control
              </h4>
            </div>
            <p className="text-xs text-muted-foreground mb-4 pl-9">
              Set the versions each app checks against on launch. Force update only blocks users below the minimum version.
            </p>

            <div className="space-y-4">
              {/* Provider app sub-group */}
              <div className="rounded-xl border border-border bg-muted/20 overflow-hidden">
                <div className="flex items-center gap-2.5 px-4 py-3 border-b border-border bg-card">
                  <div className="w-7 h-7 rounded-md bg-primary/10 text-primary flex items-center justify-center shrink-0">
                    <Smartphone size={15} />
                  </div>
                  <div className="min-w-0">
                    <p className="text-sm font-semibold text-foreground leading-tight">
                      Provider App
                    </p>
                    <p className="text-xs text-muted-foreground leading-tight">
                      Qkly Partner
                    </p>
                  </div>
                </div>

                <div className="p-4 space-y-4">
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm text-muted-foreground mb-1">
                        Min Version — iOS
                      </label>
                      <input
                        type="text"
                        {...register("provider_app_min_supported_version_ios")}
                        className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
                      />
                    </div>
                    <div>
                      <label className="block text-sm text-muted-foreground mb-1">
                        Min Version — Android
                      </label>
                      <input
                        type="text"
                        {...register("provider_app_min_supported_version_android")}
                        className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
                      />
                    </div>
                    <div>
                      <label className="block text-sm text-muted-foreground mb-1">
                        Latest Version — iOS
                      </label>
                      <input
                        type="text"
                        {...register("provider_app_latest_version_ios")}
                        className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
                      />
                    </div>
                    <div>
                      <label className="block text-sm text-muted-foreground mb-1">
                        Latest Version — Android
                      </label>
                      <input
                        type="text"
                        {...register("provider_app_latest_version_android")}
                        className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm text-muted-foreground mb-1">
                      Update Message{" "}
                      <span className="text-xs">(optional — blank uses the default)</span>
                    </label>
                    <textarea
                      rows={2}
                      {...register("provider_app_update_message")}
                      className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
                    />
                  </div>

                  <div className="flex items-center justify-between gap-3 bg-card border border-border rounded-md px-3 py-2.5">
                    <div className="flex items-center gap-2 min-w-0">
                      <ShieldAlert size={15} className="text-muted-foreground shrink-0" />
                      <span className="text-sm text-foreground">
                        Force update below the minimum version
                      </span>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer shrink-0">
                      <input
                        type="checkbox"
                        {...register("provider_app_force_update_enabled")}
                        className="sr-only peer"
                      />
                      <div className="w-10 h-5 bg-border rounded-full peer-checked:bg-primary transition-colors" />
                      <div className="absolute left-0.5 top-0.5 w-4 h-4 bg-white rounded-full shadow transition-transform peer-checked:translate-x-5" />
                    </label>
                  </div>
                </div>
              </div>

              {/* Customer app sub-group */}
              <div className="rounded-xl border border-border bg-muted/20 overflow-hidden">
                <div className="flex items-center gap-2.5 px-4 py-3 border-b border-border bg-card">
                  <div className="w-7 h-7 rounded-md bg-primary/10 text-primary flex items-center justify-center shrink-0">
                    <Smartphone size={15} />
                  </div>
                  <div className="min-w-0">
                    <p className="text-sm font-semibold text-foreground leading-tight">
                      Customer App
                    </p>
                    <p className="text-xs text-muted-foreground leading-tight">
                      Qkly
                    </p>
                  </div>
                </div>

                <div className="p-4 space-y-4">
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm text-muted-foreground mb-1">
                        Min Version — iOS
                      </label>
                      <input
                        type="text"
                        {...register("customer_app_min_supported_version_ios")}
                        className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
                      />
                    </div>
                    <div>
                      <label className="block text-sm text-muted-foreground mb-1">
                        Min Version — Android
                      </label>
                      <input
                        type="text"
                        {...register("customer_app_min_supported_version_android")}
                        className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
                      />
                    </div>
                    <div>
                      <label className="block text-sm text-muted-foreground mb-1">
                        Latest Version — iOS
                      </label>
                      <input
                        type="text"
                        {...register("customer_app_latest_version_ios")}
                        className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
                      />
                    </div>
                    <div>
                      <label className="block text-sm text-muted-foreground mb-1">
                        Latest Version — Android
                      </label>
                      <input
                        type="text"
                        {...register("customer_app_latest_version_android")}
                        className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm text-muted-foreground mb-1">
                      Update Message{" "}
                      <span className="text-xs">(optional — blank uses the default)</span>
                    </label>
                    <textarea
                      rows={2}
                      {...register("customer_app_update_message")}
                      className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
                    />
                  </div>

                  <div className="flex items-center justify-between gap-3 bg-card border border-border rounded-md px-3 py-2.5">
                    <div className="flex items-center gap-2 min-w-0">
                      <ShieldAlert size={15} className="text-muted-foreground shrink-0" />
                      <span className="text-sm text-foreground">
                        Force update below the minimum version
                      </span>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer shrink-0">
                      <input
                        type="checkbox"
                        {...register("customer_app_force_update_enabled")}
                        className="sr-only peer"
                      />
                      <div className="w-10 h-5 bg-border rounded-full peer-checked:bg-primary transition-colors" />
                      <div className="absolute left-0.5 top-0.5 w-4 h-4 bg-white rounded-full shadow transition-transform peer-checked:translate-x-5" />
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex items-center justify-between">
            {/* RESET BUTTON */}
            <button
              type="button"
              disabled={isPending || isResetting}
              onClick={handleReset}
              className="px-4 py-2 border border-destructive text-destructive rounded-md hover:bg-destructive hover:text-white disabled:opacity-50 transition-colors"
            >
              {isResetting ? "Resetting..." : "Reset to Default"}
            </button>

            <div className="flex gap-3">
              <button
                type="button"
                disabled={isPending}
                onClick={onClose}
                className="px-4 py-2 border border-border text-muted-foreground rounded-md hover:bg-accent hover:text-foreground transition-colors"
              >
                Cancel
              </button>

              <button
                type="submit"
                disabled={isPending}
                className="px-4 py-2 bg-primary hover:bg-primary/90 text-primary-foreground rounded-md transition-colors disabled:opacity-50"
              >
                {isPending ? "Updating..." : "Update settings"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
